// extracted by mini-css-extract-plugin
export default {"LoadError":"bfa_a bhn_qs bhn_a bhn_w bhn_j bhn_q","LoadError__icon":"bfa_b bhn_vl bhn_fm bhn_sw","LoadError__message":"bfa_c bhn_fm bhn_tr"};